<template>
  <section class="timeline">
    <div class="timeline__content container">
      <h1 class="timeline__title --fade-in-right" data-vertical-ivp-class="--animate">
        A GEMXX Timeline: <br> Progressing Through 2025 and Beyond 
      </h1>

      <p class="timeline__description --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        What makes GEMXX special? Aside from working with one of the rarest gemstones on the planet — one
        in which the Company owns a substantial amount of gemstone-bearing land in the only region it can
        be found — GEMXX's future plans target reaching full vertical integration. This means from extraction
        to jewelry sales and even global marketing, the company is maximizing reach, value, and growth at
        every step of the process.
      </p>
      <p class="timeline__description-bold --fade-in-up --delay-2" data-vertical-ivp-class="--animate">
        So what does that look like? Well, something like this:
      </p>
      <hr class="timeline__divider --fade-in-up --delay-4" data-vertical-ivp-class="--animate">
    </div>
  </section>
  <section class="timeline__image">
    <img src="../assets/timeline/modelled.png" alt="Modelled Timeline">
  </section>
</template>

<script>
export default {
  name: 'Timeline',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/timeline.scss";
</style>
